import _ from 'underscore';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { serverContextProps } from './server-context-props';

export const ServerContext = React.createContext();

export const withServerContext = WrappedComponent => (
  props => (
    <ServerContext.Consumer>
      {(serverContext =>
            (<WrappedComponent
              {...props}
              serverContext={serverContext}
            />))}
    </ServerContext.Consumer>
  )
);

export const ServerContextAction = React.createContext(_.noop);

export const ServerContextWithActionProvider = (props) => {
  const {
    context,
    children,
  } = props;

  const [serverContext, setServerContext] = useState(context);

  return (
    <ServerContextAction.Provider
      value={setServerContext}
    >
      <ServerContext.Provider value={serverContext}>
        {children}
      </ServerContext.Provider>
    </ServerContextAction.Provider>
  );
};

ServerContextWithActionProvider.propTypes = {
  context: serverContextProps.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
